import type { Unit } from '@/services/api';

type SortableUnit = Pick<Unit, 'sortOrder' | 'beds24RoomId' | 'beds24UnitId'>;

/**
 * Ordre físic de les habitacions (`unit_config.sort_order`).
 * Un `sortOrder` 0 és vàlid (abans `|| 999` el tractava com a buit). Sense `sortOrder`, al final.
 * Empats: per `beds24RoomId` i després per `beds24UnitId`, com feia el calendari v1.
 */
export function compareUnitsBySortOrder(a: SortableUnit, b: SortableUnit): number {
  return (
    (a.sortOrder ?? 999) - (b.sortOrder ?? 999) ||
    a.beds24RoomId - b.beds24RoomId ||
    a.beds24UnitId - b.beds24UnitId
  );
}
